import React, { useRef, useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import m61 from './Asset/m6-1.webp';
import m62 from './Asset/m6-2.webp';
import m63 from './Asset/m6-3.webp';
import m64 from './Asset/m6-4.webp';
import m65 from './Asset/m6-5.webp';
import m66 from './Asset/m6-6.webp';
import brochure from './Asset/Brosur-BYD-M6-Sep24.jpg';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function JelajahiM6() {
  const sections = useRef([]);
  const [visibleSections, setVisibleSections] = useState({});

  const images = [
    {
      src: m61,
      title: 'BYD M6',
      specs: [
        { value: '530km', label: 'Jarak Tempuh*' },
        { value: '71,8 kWh', label: 'Kapasitas Baterai*' },
        { value: '310 Nm', label: 'Torsi Maksimum*' },
      ],
    },
    {
      src: m62,
      title: 'Desain Wajah Naga Aerodinamis',
      description: `Desain depan yang aerodinamis dan ramping mengoptimalkan aliran udara sekaligus mencerminkan kesederhanaan dan keanggunan estetika desain generasi baru BYD dengan perhatian terhadap detail yang telitix`,
    },
    {
      src: m63,
      title: 'Stasiun Daya VtoL',
      description: `Untuk memenuhi kebutuhan dasar hidup dan hiburan pelanggan RV, setiap soket dilengkapi dengan perlindungan terhadap kelebihan beban untuk mencegah terjadinya situasi berbahaya seperti korsleting atau kebakaran.`,
    },
    {
      src: m64,
      title: 'Kokpit Teknologi Cerdas',
      description: `Menghadirkan desain kokpit yang luar biasa, BYD M6 memadukan keanggunan modern dengan fungsionalitas cerdas. Mengantarkan Anda ke dimensi perjalanan baru yang penuh kecerdasan dan inovasi, menciptakan pengalaman berkendara yang tidak hanya fungsional tetapi juga sangat estetis.`,
    },
    {
      src: m65,
      title: 'Teknologi Baterai Blade Berpaten Ultra-Aman',
      description: `Selama menjalani uji penetrasi paku, Baterai Blade tidak mengeluarkan asap atau api setelah ditembus, dan suhunya hanya mencapai 30 hingga 60°C. Sel-sel Baterai Blade juga lulus uji kondisi ekstrem lainnya, seperti diremukkan, ditekuk, dipanaskan dalam tungku hingga 300°C, dan diisi daya lebih dari 260%. Tidak satu pun dari uji ini menyebabkan kebakaran atau ledakan.`,
    },
    {
      src: m66,
      title: 'BYD M6',
    },
  ];

  useEffect(() => {
    const currentSections = sections.current;

    const observer = new IntersectionObserver(
      (entries) => {
        setVisibleSections((prev) => {
          const updated = { ...prev };
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              updated[entry.target.dataset.index] = true;
            }
          });
          return updated;
        });
      },
      { threshold: 0.5 },
    );

    currentSections.forEach((section) => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      currentSections.forEach((section) => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <Box>
      <Helmet>
        <title>BYD M6 di BSD Serpong | Harga Terbaru & Promo Kredit</title>
        <meta
          name='description'
          content='Temukan informasi harga BYD M6 terbaru di Dealer Resmi BYD BSD Serpong. Cek juga harga Denza D9, Sealion 7, dan Atto1. Tersedia promo cicilan & test drive.'
        />
        <meta
          name='keywords'
          content='BYD BSD Serpong, Harga BYD M6, Harga Denza D9, Harga Sealion 7, Harga Atto1, Mobil Listrik BYD'
        />
        <meta
          property='og:title'
          content='Harga BYD M6 & Promo Kredit di BSD Serpong'
        />
        <meta
          property='og:description'
          content='Cek harga mobil listrik BYD M6 terbaru, lengkap dengan promo cicilan, test drive, dan informasi harga mobil listrik lainnya seperti Denza D9, Sealion 7, dan Atto1.'
        />
      </Helmet>
      <Typography
        variant='h1'
        component='h1'
        sx={{
          fontSize: { xs: '2rem', sm: '3rem' },
          textAlign: 'center',
          fontWeight: 'bold',
          marginBottom: 4,
          marginTop: 2,
        }}
      >
        Jelajahi BYD M6
      </Typography>
      {images.map((img, index) => (
        <Box
          key={index}
          ref={(el) => (sections.current[index] = el)}
          data-index={index}
          sx={{
            position: 'relative',
            height: '100vh',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          <Box
            component='img'
            src={img.src}
            alt={`Image ${index + 1}`}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -1,
            }}
          />

          {img.title && (
            <Box
              sx={{
                position: 'absolute',
                top: { xs: '10%', sm: '15%' },
                color: img.src === m61 ? '#000' : '#fff',
                textAlign: 'center',
                padding: 2,
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='h4'
                fontWeight='bold'
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                }}
              >
                {img.title}
              </Typography>
            </Box>
          )}

          {img.specs && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '10%', sm: '5%' },
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'center',
                gap: { xs: 2, sm: 4 },
                color: '#fff',
              }}
            >
              {img.specs.map((spec, i) => (
                <React.Fragment key={i}>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      variant='h6'
                      fontWeight='bold'
                      sx={{
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                      }}
                    >
                      {spec.value}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                      }}
                    >
                      {spec.label}
                    </Typography>
                  </Box>
                </React.Fragment>
              ))}
            </Box>
          )}

          {img.description && (
            <Box
              sx={{
                position: 'absolute',
                bottom: { xs: '15%', sm: '10%' },
                color: '#fff',
                textAlign: 'center',
                padding: 2,
                maxWidth: { xs: '90%', sm: '80%' },
                background: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '8px',
                transform: visibleSections[index]
                  ? 'translateY(0)'
                  : 'translateY(100%)',
                opacity: visibleSections[index] ? 1 : 0,
                transition: 'all 0.8s ease-in-out',
              }}
            >
              <Typography
                variant='body1'
                fontWeight='400'
                lineHeight='1.5'
                sx={{
                  fontSize: { xs: '0.9rem', sm: '1rem' },
                }}
              >
                {img.description}
              </Typography>
            </Box>
          )}

          {img.src === m66 && (
            <Button
              href={brochure}
              download='Brosur-BYD-M6-Sep24.jpg'
              variant='outlined'
              sx={{
                position: 'absolute',
                bottom: '10%',
                borderColor: '#fff',
                color: '#fff',
                fontSize: { xs: '0.9rem', sm: '1rem' },
                fontWeight: 600,
                padding: { xs: '8px 16px', sm: '10px 20px' },
                '&:hover': {
                  backgroundColor: '#fff',
                  color: '#000',
                },
              }}
            >
              Download Brosur
            </Button>
          )}
        </Box>
      ))}
      <Box sx={{ padding: { xs: 3, sm: 6 }, backgroundColor: '#f9f9f9' }}>
        <Typography
          variant='h2'
          sx={{
            fontSize: { xs: '1.5rem', sm: '2rem' },
            fontWeight: 600,
            textAlign: 'center',
            mb: 2,
          }}
        >
          Tertarik dengan BYD M6? 🚐
        </Typography>
        <Typography variant='body1' sx={{ textAlign: 'center', mb: 3 }}>
          Temukan <strong>BYD M6</strong> terbaik hanya di{' '}
          <strong>Dealer Resmi BYD BSD Serpong</strong>. Kami menyediakan
          informasi lengkap seputar <strong>Harga Denza D9</strong>,{' '}
          <strong>Harga Sealion 7</strong>, dan <strong>Harga Atto1</strong>{' '}
          untuk Anda yang sedang mempertimbangkan mobil listrik keluarga, SUV,
          atau MPV terbaik di kelasnya.
        </Typography>
        <Link to='/pricing' style={{ textDecoration: 'none' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: 2,
            }}
          >
            <Box
              sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                padding: 2,
                minWidth: 250,
                textAlign: 'center',
                backgroundColor: '#fff',
              }}
            >
              <Typography variant='h6' fontWeight={600}>
                Harga BYD M6
              </Typography>
              <Typography variant='body2'>
                Hubungi kami untuk info harga dan promo cicilan BYD M6 terbaru.
              </Typography>
            </Box>
            <Box
              sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                padding: 2,
                minWidth: 250,
                textAlign: 'center',
                backgroundColor: '#fff',
              }}
            >
              <Typography variant='h6' fontWeight={600}>
                Harga Denza D9
              </Typography>
              <Typography variant='body2'>
                MPV premium untuk Anda yang mencari kenyamanan dan kemewahan.
              </Typography>
            </Box>
            <Box
              sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                padding: 2,
                minWidth: 250,
                textAlign: 'center',
                backgroundColor: '#fff',
              }}
            >
              <Typography variant='h6' fontWeight={600}>
                Harga Sealion 7
              </Typography>
              <Typography variant='body2'>
                SUV listrik dengan fitur canggih dan performa luar biasa.
              </Typography>
            </Box>
            <Box
              sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                padding: 2,
                minWidth: 250,
                textAlign: 'center',
                backgroundColor: '#fff',
              }}
            >
              <Typography variant='h6' fontWeight={600}>
                Harga Atto1
              </Typography>
              <Typography variant='body2'>
                Mobil listrik kompak yang efisien dan ramah lingkungan.
              </Typography>
            </Box>
          </Box>
        </Link>
        <Box sx={{ textAlign: 'center', marginTop: 4 }}>
          <Button
            href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo,%20saya%20tertarik%20dengan%20BYD%20M6%20dan%20ingin%20tahu%20harganya'
            target='_blank'
            variant='contained'
            color='primary'
            sx={{ fontWeight: 600 }}
          >
            Konsultasi Harga BYD M6 Sekarang
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default JelajahiM6;
